import axios from "axios";
import { Urls } from "../slices/urls";
import {ServiceUrls} from '../serviceUrl'

// const subDomain = window.location?.host?.split(".")?.splice(1)?.join(".");
// const subDomainName = window.location?.host?.includes("localhost")
//   ? ".careers360.de"
//   : `.${subDomain}`;

export const postStudyabroadIdpRepo = (data) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "POST",
    url: Urls.POST_IDP_STUDYABROAD_API,
    data: data,
  });
};

export const getStudyabroadIdpStatusRepo = (params) => {
  return axios({
    baseURL: ServiceUrls.IDP_SERVICE + axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME,
    method: "GET",
    url: Urls.GET_IDP_ENGINEERING_API,
    params: params,
  });
};
